import { create } from 'zustand';
import Alertas from '../alerts/AlertasGernericos';
import CryptoJS from 'crypto-js';
import apiClient from '../api/client';


export const useUsuariosStore = create((set, get) => ({

    carregando: false,
    logado: false,
    pagina_atual: 1,
    ultima_pagina: 0,
    hanking_de_grupos: [],
    total_de_grupos_ja_vendidos: 0,
    mostrar_grafico: true,
    deletingId: 0,
    usuarios: [],
    cod_produto: 0,
    filtrosDeBusca: null,


    setIdUserDelete: (valor) => set({ deletingId: valor }),

    searchUsuarios: async (filtros) => {

        set({ carregando: 'searching', pagina_atual: 1 });

        try {
            const response = await apiClient.get('/PesquisarPorUsuario', {
                params: {
                    nome: filtros.nm_usuario,
                    tipo: filtros.tipo,
                    id: filtros.id,
                }
            });
            console.log("teste de dados", response)

            const { data, last_page, current_page } = response.data.dados;

            if (!data || !response) {
                throw new Error("Não foi possível carregar os produtos.");
            }


            set({
                usuarios: data,
                pagina_atual: current_page,
                ultima_pagina: last_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.data?.message || "Não foi encotrado nenhum produto com esses dados.");
            set({ carregando: 'idle' });
        }
    },

    fetchUsuarios: async (page = 1) => {
        set({ carregando: 'fetching' });
        try {

            const resposta = await apiClient.get('/GetUsuarios', {
                params: { page: page }
            });

            const { data, current_page, last_page } = resposta.data.dados;


            if (!data || !resposta) {
                throw new Error("Não foi possível carregar os produtos.");
            }

            set({
                usuarios: data,
                pagina_atual: current_page,
                ultima_pagina: last_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar produtos.");
            set({ carregando: 'idle' });
        }
    },

    SalvarUsuario: async (usuario) => {
        set({ carregando: 'updating' });
        try {

            const { Refresh, pagina_atual, fetchUsuarios } = get();
            const id = usuario.id ?? '';
            const nome = usuario.nm_usuario ?? '';
            const tipo = usuario.tipo ?? '';

            const response = await apiClient.post('/CriarOuEditarFuncionario', {
                usuario: usuario,
            });

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            if (id != '') await Refresh(id, nome, tipo);

            if (id === '') await fetchUsuarios(pagina_atual);

            set({ carregando: 'idle' });
            Alertas.ExibirAlertaSucesso(message);

        } catch (error) {
            set({ carregando: 'idle' });
            Alertas.ExibirAlertaErro(error.message || "Erro ao fazer essa operação, tente novamente.");
        }
    },

    Refresh: async (id, nome, tipo) => {

        const { usuarios } = get();

        usuarios.map((user) => {

            if (user.id == id) {
                user.nome = nome ?? "Indefinido"
                user.tipo = tipo ?? ""
            }
        })

        set({ usuarios: usuarios })
    },

    RefreshDelete: async (id) => {
        const { usuarios } = get();
        let users = usuarios.filter(user => user.id != id);
        set({ usuarios: users })
    },

    DeletarUsuario: async () => {
        set({ carregando: 'delete' });
        try {

            const { RefreshDelete, deletingId } = get();

            const response = await apiClient.delete('/RemoverUsuario', {
                data: { deletingId }
            });

            if (!response) {
                throw new Error("Verifique sua conexão com a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            await RefreshDelete(deletingId);
            Alertas.ExibirAlertaSucesso(message);
            set({ carregando: 'idle', deletingId: 0 });

        } catch (error) {
            set({ carregando: 'idle' });
            Alertas.ExibirAlertaErro(error.message || "Erro ao remover sua imagem.");
        }
    },

}));



